import React from 'react';

const Resume = () => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh', width: '100%' }}>
      <iframe
        src="/Resume.pdf"
        title="Resume PDF"
        style={{
          flex: 1,
          border: 'none',
          width: '100%',
        }}
      />
      <a
        href="/Resume.pdf"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          display: 'block',
          padding: '12px 16px',
          textAlign: 'center',
          backgroundColor: '#232526',
          color: '#ec950c',
          fontSize: '0.875rem',
          fontFamily: 'Arial, sans-serif',
          textDecoration: 'none',
          borderTop: '1px solid rgba(255,255,255,0.1)',
          minHeight: '44px',
          lineHeight: '20px',
        }}
      >
        Open resume in new tab
      </a>
    </div>
  );
};

export default Resume;
